import React, { useEffect, useRef, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { MIS_PULSE_LIST_HEADERS } from '../../constants/tableHeaders'
import { misPulseSchema } from '../../schemas/table'
import { Breadcrumb, Spinner } from '../common/atoms'
import { handleAppError } from '../handlers'
import { Tabbar, Table } from '../common/molecules'
import MisApi from '../../services/mis.api'

const misPage = () => {
  const history = useHistory()
  const [state, setState] = useState(
    {
      tableData: [],
      currentTab: '',
      status: '',
      tableLoading: true,
      active: [],
      inactive: []
    }
  )
  const [refresh, setRefresh] = useState(false)
  const list = useRef(['Active (0)', 'Inactive (0)'])
  const setSubState = (newState) => {
    setState(prevState => { return { ...prevState, ...newState } })
  }

  const createMisPulse = () => {
    history.push({ pathname: 'mis-pulse/add', state: { disabled: state.disableCreateStepathon, total_employee_count: state.total_employee_count } })
  }

  const fetchMisList = () => {
    MisApi.fetchMisPulseList(
      {},
      (resp) => {
        const data = resp.data.mis_pulses
        const active = data.filter((item) => item.status === 'active')
        const inactive = data.filter((item) => item.status === 'inactive')
        list.current = [`Active (${active.length})`, `Inactive (${inactive.length})`]
        if (data.length > 0)
          setSubState({ tableData: active, active: active, inactive: inactive, currentTab: `Active (${active.length})`, tableLoading: false })
        else setSubState({ showUtilization: true, tableLoading: false })
      },
      (err) => {
        handleAppError(err);
        setSubState({ tableLoading: false })
      }
    );
  }

  useEffect(() => {
    fetchMisList()
  }, [refresh])

  const navigateTab = (tab) => {
    let newState = {}
    if (tab.text === `Inactive (${state.inactive.length})`) {
      newState = { ...newState, tableData: state.inactive }
    }
    else newState = { ...newState, tableData: state.active }

    setSubState({ ...newState, currentTab: tab.text })
  }

  return (
    <Spinner visible={state.tableLoading} classes='ml-32 z-10' >
      <React.Fragment>
        <div className='flex flex-row justify-between'>
          <div>
            <Breadcrumb
              list={[
                { text: 'Analytics', link: '/mis-pulse' },
                { text: 'Mis Pulse', link: '/mis-pulse' },
              ]}
              classes='mb-1'
            />
            <p className='text-gray-900 text-xl font-semibold leading-5 mb-0'>Mis Pulse List</p>
          </div>
          <button
            type='button'
            onClick={createMisPulse}
            style={{ height: '44px', width: '172px' }}
            className='block rounded-md leading-5 px-6 py-3 bg-blue-600  text-base font-semibold text-white focus:outline-none'
          >
            Create Mis Pulse
          </button>
        </div>
        <div className='mt-6'>
          <Tabbar
            titleClasses='pb-3 leading-4'
            list={list.current.map((text) => ({ text }))}
            currentPage={state.currentTab || list.current[0]}
            setContract={navigateTab}
          />
        </div>
        <div className='mt-6'>
          <div>
            <Table
              headers={MIS_PULSE_LIST_HEADERS}
              data={state.tableData || []}
              tableClasses='alternate_gray200_color'
              tableschema={misPulseSchema}
              classes='rounded-md'
              setRefresh={setRefresh}
            />
          </div>
        </div>
      </React.Fragment>
    </Spinner>
  )
}

export default misPage